import {
  Component,
  inject,
} from '@angular/core';

import {
  CommonModule,
} from '@angular/common';

import {
  FormsModule,
  NgForm,
} from '@angular/forms';

import Swal from 'sweetalert2';
import { TestimonialService } from '../../services/testimonial.service';
import { Testimonial } from '../../models/testimonial.interface';


@Component({
  selector: 'app-testimonials',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,],
  templateUrl: './testimonials.html',
  styleUrl: './testimonials.scss',
})
export class Testimonials {
  private testimonialService = inject(TestimonialService);

  isSendingTestimonial = false;

  testimonialData: Omit<Testimonial, 'id'> = {
    name: '',
    location: '',
    message: '',
    rating: 5,
  };

  sendTestimonial(form: NgForm): void {
    if (form.invalid) {
      return;
    }

    this.isSendingTestimonial = true;

    const testimonialToSend: Omit<Testimonial, 'id'> = {
      name: this.testimonialData.name.trim(),
      location: this.testimonialData.location.trim(),
      message: this.testimonialData.message.trim(),
      rating: Number(this.testimonialData.rating),
    };

    this.testimonialService
      .createTestimonial(testimonialToSend)
      .subscribe({
        next: () => {
          Swal.fire({
            icon: 'success',
            title: 'Testimonial Sent',
            text: 'Thank you for sharing your experience.',
            confirmButtonText: 'Continue',
            confirmButtonColor: '#562a73',
          });

          form.resetForm({
            testimonialRating: 5,
          });

          this.testimonialData = {
            name: '',
            location: '',
            message: '',
            rating: 5,
          };

          this.isSendingTestimonial = false;
        },
        error: (error) => {
          console.error(error);

          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong. Please try again.',
            confirmButtonColor: '#562a73',
          });

          this.isSendingTestimonial = false;
        },
      });
  }
}
